import axios from '../../axios';

// ANGEL TO DO IN TECH DEBT - MOVE ALL TO RESULTS MODULE AND COMMON

// TO DO : REMOVE ALL OLD DATE REFS SITE WIDE

export default {
  namespaced: true,
  state: {
    selectedDates: '',
    selectedArrival: '',
    selectedDeparture: '',
    selectedFilter: '',
    selectedAmenities: [],
    amenities: [],
    filteredAmenities: [],
    filterbarfixed: false,
    footerInView: false,
    dates: null,
    villaDates: null,
    mobileFiltersText: {},
  },
  getters: {
    getDates: (state) => state.dates,
    getVillaDates: (state) => state.villaDates,
    getSelectedArrival: (state) => state.selectedArrival,
    getSelectedDeparture: (state) => state.selectedDeparture,
    getSelectedFilter: (state) => state.selectedFilter,
    getSelectedDates: (state) => state.selectedDates,
    getSelectedAmenities: (state) => state.selectedAmenities,
    getFilteredAllAmenities: (state) => state.filteredAmenities,
    getFilterbarfixed: (state) => state.filterbarfixed,
    getFooterInView: (state) => state.footerInView,
    getMobileFiltersData: (state) => state.mobileFiltersText,
    isDatesFilterActive: (state) => !!state.dates && !!state.dates.endDate,
    urlHasFilters() {
      return !!(window.$router.app._route.query.des
        || window.$router.app._route.query.subdes
        // || window.$router.app._route.query.from
        // || window.$router.app._route.query.to
        || (window.$router.app._route.query.people && window.$router.app._route.query.people > 0)
        || (window.$router.app._route.query.rooms && window.$router.app._route.query.rooms > 0)
        || window.$router.app._route.query.minprice
        || window.$router.app._route.query.maxprice
        || window.$router.app._route.query.tev
        || window.$router.app._route.query.amenities)
        || false;
    },
  },
  mutations: {
    setDates(state, payload) {
      state.dates = payload;
    },
    setVillaDates(state, payload) {
      state.villaDates = payload;
    },
    setSelectedArrival(state, arrival) {
      state.selectedArrival = arrival;
    },
    setSelectedDeparture(state, departure) {
      state.selectedDeparture = departure;
    },
    setSelectedFilter(state, filter) {
      state.selectedFilter = filter;
    },
    setSelectedDates(state, payload) {
      state.selectedDates = payload;
    },
    setSelectedAmenities(state, selected) {
      state.selectedAmenities = selected;
    },
    setFilteredAllAmenities(state, filteredAllAmenities) {
      state.filteredAmenities = filteredAllAmenities;
    },
    setFooterInView(state, status) {
      state.footerInView = status;
    },
    setFilterbarfixed(state, status) {
      state.filterbarfixed = status;
    },
    setMobileFiltersData(state, data) {
      state.mobileFiltersText = data;
    },

  },
  actions: {
    // filterAllAmenities({ commit, dispatch, getters }, p) {
    //  // axios.get(`/core/amenities/filteringgroups/lang/en?$select=id,name&$filter=allowFiltering%20eq%20${p.allowFiltering}%20and%20live%20eq%20${p.live}%20and%20deleted%20eq%20${p.deleted}%20and%20name%20ne%20%27${p.name}%27&$orderby=${p.orderby}`)
    //  axios.get('/core/amenities/filteringgroups/lang/en?$select=id,name,allowFiltering,live,deleted')
    //    .then((res) => {
    //      commit('setFilteredAllAmenities', res.data);
    //    })
    //    .catch((error) => console.log(error));
    // },
  },
};
